module.exports = __webpack_public_path__ + "static/media/ebarchitects_kabeza20215.522e77c4.jpg";